export default {"src":"/_next/static/media/HUBS.251b3eee.svg","height":18,"width":18};